module.exports = __webpack_public_path__ + "img/yi6.22cc9139.jpg";